import { useMutation } from '@apollo/client';

import LearnerObjectUpdateFullNameMutation from 'bundles/expression-of-interest/queries/LearnerObjectUpdateFullName.graphql';
import type {
  LearnerObject_UpdateFullNameMutation as LearnerObjectUpdateFullNameMutationType,
  LearnerObject_UpdateFullNameMutationVariables as LearnerObjectUpdateFullNameMutationVariables,
} from 'bundles/expression-of-interest/queries/__generated__/LearnerObjectUpdateFullName';

const useLearnerObjectUpdateFullName = () => {
  const [updateFullNameMutation] = useMutation<
    LearnerObjectUpdateFullNameMutationType,
    LearnerObjectUpdateFullNameMutationVariables
  >(LearnerObjectUpdateFullNameMutation, {
    context: { clientName: 'gatewayGql' },
    errorPolicy: 'all',
  });

  const updateFullName = async (fullName: string) => {
    const { data, errors } = await updateFullNameMutation({ variables: { input: { fullName } } });

    if (errors) {
      return { success: false, errors: errors.map((error) => error.message) };
    }

    if (data?.LearnerObject_UpdateFullName?.__typename === 'LearnerObject_UpdateFullNameResultError') {
      return { success: false, errors: [data.LearnerObject_UpdateFullName.message] };
    }

    return { success: true, errors: [] };
  };

  return { updateFullName };
};

export default useLearnerObjectUpdateFullName;
